import * as React from 'react';
import classNames from 'clsx';
import Line from "./Line";
import TextAligner from "./TextAligner";
const AlignInfo = ({
  boundary = true,
  height,
  lines = []
}) => {
  const overlayClasses = classNames('AlignInfo-overlay', {
    'AlignInfo-overlay--boundary': boundary
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "AlignInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: overlayClasses
  }, /*#__PURE__*/React.createElement(TextAligner, null), lines.map((strategy, i) => /*#__PURE__*/React.createElement(Line, {
    key: i,
    strategy: strategy
  }))));
};
export default AlignInfo;